<template>
  <div class="special-actions">
    <template v-if="listActions && listActions.length">
      <component v-for="(action, index) in listActions"
                 :class="action.classes"
                 :disabled="action.disabled"
                 :href="action.href"
                 :is="action.component"
                 :key="index"
                 :loading="action.loading"
                 :target="action.target"
                 :type="action.type"
                 :underline="action.underline"
                 @click="action.click">
        <font-awesome-icon v-if="action.icon" :icon="action.icon" />
        {{ action.content }}
      </component>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import offersHelper from '@/utils/helpers/offers';
import MoveManager from '@/utils/components/MoveManager.vue';

export default {
  name: 'SpecialActions',
  extends: MoveManager,
  data() {
    return {
      defaultLink: {
        classes: 'special-actions--link button-link',
        target: '_blank',
        underline: false,
        click: (() => {}),
        href: undefined,
        disabled: true,
        component: 'el-link',
      },
      defaultButton: {
        type: 'success',
        disabled: false,
        icon: ['fas', 'arrow-right'],
        component: 'el-button',
        click: (() => {}),
        loading: undefined,
      },
    };
  },
  computed: {
    ...mapGetters({
      optionsLoading: 'offerStore/optionsLoading',
      comparatorConfig: 'configStore/comparatorConfig',
    }),
    listActions() {
      const listActions = [];
      if (!this.isInitialStatus || this.isIndividual || this.showAllDevis) {
        listActions.push({
          ...this.defaultLink,
          disabled: this.isFirstStatus && !this.isIndividual && !this.showAllDevis,
          href: this.offer.url,
          content: this.quotationLabel,
        });
      }
      if (this.isWaitingforQuotation && (this.isIndividual || this.showAllDevis)) {
        listActions.push({
          ...this.defaultLink,
          content: this.waitingQuotationLabel,
        });
      }
      if (this.isInitialStatus) {
        listActions.push({
          ...this.defaultButton,
          loading: this.optionsLoading,
          disabled: !this.isInitialState,
          click: this.saveOffer,
          icon: undefined,
          content: this.$t(`comparator.offers.offer.preBooking${
            (this.isIndividual && 'Individual') || ''}`),
        });
      }
      if (this.isFinishedStatus && !this.isSigned && !this.isFinished) {
        listActions.push({
          ...this.defaultButton,
          click: this.signOffer,
          content: this.$t('comparator.offers.offer.signQuotation'),
        });
      }
      if ((this.isFinishedStatus && (this.isSigned || this.isFinished)) || this.isValidForPcd) {
        listActions.push({
          ...this.defaultButton,
          loading: this.optionsLoading,
          disabled: this.isFinishedStatus || this.optionsLoading,
          click: this.chooseOffer,
          content: this.chooseQuotationLabel,
        });
      }
      if (this.isValidationStatus && !this.isValidForPcd) {
        listActions.push({
          ...this.defaultButton,
          disabled: true,
          content: this.$t('comparator.offers.offer.preReservationQuotation'),
        });
      }
      return listActions;
    },
    quotationLabel() {
      if (this.isFirstStatus && !this.isIndividual && !this.showAllDevis) {
        return this.$t('comparator.offers.offer.quotationPreparation');
      }
      return this.isSigned && this.isFinishedStatus
        ? this.$t('comparator.offers.offer.openQuotationSigned')
        : this.$t('comparator.offers.offer.openQuotation');
    },
    waitingQuotationLabel() {
      return this.$t('comparator.offers.offer.validationPreparation');
    },
    chooseQuotationLabel() {
      if (this.isFinishedStatus) {
        return this.$t('base.validate');
      }
      return this.isIndividual
        ? this.$t('base.sign')
        : this.$t('base.choose');
    },
    showAllDevis() {
      return !!this.projectSelected.params.show_devis_before_prebook;
    },
    isWaitingforQuotation() {
      return offersHelper.isWaitingforQuotation(this.offer);
    },
    isValidationStatus() {
      return offersHelper.isValidationStatus(this.offer);
    },
    isFirstStatus() {
      return this.isInitialStatus || this.isWaitingforQuotation;
    },
    isInitialState() {
      return offersHelper.isInitialState(this.offers, this.projectSelected.params.prebooked);
    },
  },
  methods: {
    ...mapActions({
      displaySigning: 'comparatorStore/displaySigningModal',
      postOptions: 'offerStore/postOptions',
    }),
    async saveOffer() {
      this.$store.dispatch('actionsStore/track', 'openPrebook');
      await this.setOptions();
      this.$router.push({
        name: 'booking',
        params: {
          id: this.offer.id,
        },
        hash: this.comparatorConfig && this.comparatorConfig.services ? '#services' : '#resume',
      });
    },
    async chooseOffer() {
      this.$store.dispatch('actionsStore/track', 'openBook');
      await this.setOptions();
      this.$router.push({
        name: 'booking',
        params: {
          id: this.offer.id,
        },
        hash: '#resume',
      });
    },
    async setOptions() {
      const offerOptions = {
        id: this.offer.id,
        options: this.offer.options.reduce((acc, option) => {
          if (option.is_chosen) {
            acc.push(option.id);
          }
          return acc;
        }, []),
      };
      await this.postOptions(offerOptions);
    },
    signOffer() {
      this.displaySigning(this.offer);
    },
  },
};
</script>

<style lang="scss" scoped>

.special-actions {
  justify-content: center;
  display: flex;
  flex-direction: column;
  &--link {
    vertical-align: top;
    font-weight: 500;
    &:not(:last-child) {
      margin-bottom: 20px;
    }

    :deep(.el-link--inner) {
      display: flex;
      align-items: center;

      svg {
        padding-right: 3px;
      }
    }
  }
}

</style>
